import { uniqueId } from "@/views/zhiji/js/common/util.js";
import { ParamError } from "@/views/zhiji/js/common/errors.js";
import i18n from "@/i18n";

export default {
    widgetName: "Guides",
    serverType: "singleTip",
    initContent() {
        return {
            uId: uniqueId(),
            updateState: "add",
            wtType: "Guides",
            name: ""
        };
    },
    checkContent(content) {
        if (!content.name || !content.cardImage) {
            throw new ParamError(i18n.t("zhiji.answer.guidesWidgeEmpty"));
        }
    },
    server2Client(content) {
        return {
            uId: uniqueId(),
            wtType: "Guides",
            updateState: "",
            resourceId: content.resource_id,
            cardImage: content.image || "", //封面图
            name: content.name || "",
            contentType: content.content_type || ""
        };
    },
    client2Server(content) {
        return {
            type: "tip",
            resource_id: content.resourceId,
            image: content.cardImage, //封面图
            name: content.name,
            url: "",
            content_type: "2",
            content_format: "1"
        };
    }
};
